import { FieldConfigPropertyItem } from '../types/fieldOverrides';
import { Registry } from '../utils/Registry';

export class FieldConfigOptionsRegistry extends Registry<FieldConfigPropertyItem> {}
